module.exports = __webpack_public_path__ + "static/media/loja_virtual.4b343735.png";